/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Button } from '@mairistem/composants';

interface PanelButtonEditionProps {
  onClick: () => void;
  'data-testid'?: string;
}
const PanelButtonEdition = (props: PanelButtonEditionProps) => {
  const { onClick, 'data-testid': dataTestId = 'panel-edit-modal' } = props;

  return (
    <Button
      style={{
        marginRight: '-20px',
        position: 'absolute',
        right: 0,
        top: 0,
        zIndex: 1,
      }}
      size="small"
      icon="edit"
      basic
      onClick={onClick}
      data-testid={dataTestId}
    />
  );
};

export default PanelButtonEdition;
